import { useTranslation } from "react-i18next"
import "./style.css"

const ModalContainer = ({ children, isOpen, onClose, text, info }) => {
    const { t } = useTranslation();
    return (
        <>
            <div
                className={`modal show`}
                id="orderDetailModal"
                tabIndex="-1"
                aria-hidden={!isOpen}
                style={{ display: "block" }}
            >
                <div className="modal-dialog modal-xl modal-dialog-scrollable custom-modal">
                    <div className="modal-content custom-modal">
                        <div className="modal-header">
                            <h5 className="modal-title custom-modal-title">{text}</h5>
                            <button
                                type="button"
                                className="btn-close"
                                onClick={onClose}
                                aria-label="Close"
                            ></button>
                        </div>
                        {
                            info && (
                                <p className="modal-info">{info}</p>
                            )
                        }
                        <div className="modal-body custom-modalbody">
                            
                            {children}
                            
                            
                            
                            </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary custom-modal-btn"
                                onClick={onClose}
                            >
                                {t("properties.close")}
                            </button>
                        </div>

                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show" onClick={onClose}></div>
        </>
    );
};


export default ModalContainer